import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { FaDownload, FaFileAlt, FaGithub } from "react-icons/fa";

const Downloads = () => {
  const [latestRelease, setLatestRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestRelease = async () => {
      try {
        const response = await axios.get(
          "https://api.github.com/repos/MenelikCoin/menelik/releases/latest"
        );
        setLatestRelease(response.data);
      } catch (err) {
        setError("Failed to fetch the latest release.");
      } finally {
        setLoading(false);
      }
    };

    fetchLatestRelease();
  }, []);

  return (
    <section id="downloads" className="py-12 px-4 bg-cover bg-center relative">
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      <div className="relative max-w-4xl mx-auto text-center">
        <motion.a
          href="https://github.com/MenelikCoin/menelik/releases"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-400 text-lg font-semibold flex items-center justify-center mb-4 hover:text-yellow-300 transition-colors"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <FaGithub className="mr-2 text-2xl" /> Menelik GitHub Releases
        </motion.a>

        {loading ? (
          <p className="text-gray-200">Loading downloads...</p>
        ) : error ? (
          <p className="text-red-400">{error}</p>
        ) : latestRelease ? (
          <motion.div
            className="bg-black bg-opacity-50 p-6 rounded-lg shadow-md backdrop-blur-md border-l-4 border-yellow-400 text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <ul className="list-none space-y-2">
              {latestRelease.assets.map((asset) => (
                <li key={asset.id} className="flex items-center">
                  <FaFileAlt className="text-yellow-400 mr-2" />
                  <a
                    href={asset.browser_download_url}
                    className="text-yellow-400 hover:text-yellow-300 transition-colors flex items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {asset.name} ({(asset.size / 1024 / 1024).toFixed(2)} MB)
                    <FaDownload className="ml-2" />
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        ) : (
          <p className="text-gray-200">No available downloads.</p>
        )}
      </div>
    </section>
  );
};

export default Downloads;
